import { cloneElement, Fragment, isValidElement, ReactElement } from "react";
import { ISideTreeCustom } from "../../interfaces";

export default function SideTreeCustomComponent(props: Readonly<ISideTreeCustom>) {
	const { component = null, ...additional } = props;

	if (component && Boolean(isValidElement(component))) {
		return <Fragment>{cloneElement(component as ReactElement, { ...props, ...additional })}</Fragment>;
	}

	return null;
}
